/* eslint-disable no-console */
import dbInstance from "../instance";
import { IColelctionObject } from "../schemas";

const buildId = (documentId: string, objectId: string, revision: string) =>
    `NU_C#${documentId}#${objectId}#${revision}`;

interface ICollectionObjectKey {
    documentId: string;
    objectId: string;
    revision: string;
}

interface ISaveCollectionObjectOptions extends ICollectionObjectKey {
    value: string;
    createdAt: number;
}

export function saveCollectionObject(options: ISaveCollectionObjectOptions): Promise<IColelctionObject | null> {
    const { documentId, objectId, revision, value, createdAt } = options;
    const id = buildId(documentId, objectId, revision);

    return new Promise((resolve, reject) => {
        dbInstance
            .transaction("rw?", dbInstance.table("collectionObjects"), () => {
                const dataToStore: IColelctionObject = {
                    id,
                    createdAt,
                    value,
                };

                return dbInstance
                    .table("collectionObjects")
                    .update(id, dataToStore)
                    .then((updated) => {
                        // If not updated, that means no record previous created. Create one.
                        if (!updated) {
                            return dbInstance
                                .table("collectionObjects")
                                .add(dataToStore)
                                .then(() => {
                                    resolve(dataToStore);
                                });
                        }

                        resolve(dataToStore);
                    });
            })
            .catch((err) => {
                console.error(err);
                if (err.name === "QuotaExceededError" || err.inner?.name === "QuotaExceededError") {
                    deleteCollectionObjects().catch((e) => reject(e.stack));
                } else {
                    reject(err.stack);
                }
            });
    });
}

export function deleteCollectionObjects(createAtTimestamp?: number): Promise<void> {
    return new Promise((resolve, reject) => {
        dbInstance
            .transaction("rw?", dbInstance.table("collectionObjects"), () => {
                if (!createAtTimestamp) {
                    return dbInstance
                        .table("collectionObjects")
                        .clear()
                        .then(() => true);
                }
                return dbInstance
                    .table("collectionObjects")
                    .where("createdAt")
                    .below(createAtTimestamp)
                    .delete()
                    .then(() => true);
            })
            .then(() => {
                resolve();
            })
            .catch((err) => {
                console.error(err);
                reject(err.stack);
            });
    });
}

export function getCollectionObject(options: ICollectionObjectKey): Promise<IColelctionObject | null> {
    const { documentId, revision, objectId } = options;
    const id = buildId(documentId, objectId, revision);

    return new Promise((resolve, reject) => {
        dbInstance
            .transaction("r?", dbInstance.table("collectionObjects"), () => {
                return dbInstance
                    .table("collectionObjects")
                    .get(id)
                    .then((pendingMutation) => {
                        return pendingMutation || null;
                    });
            })
            .then((pendingMutation) => {
                resolve(pendingMutation);
            })
            .catch((err) => {
                console.error(err);
                reject(err.stack);
            });
    });
}
